import axios from "axios";
import { toast } from 'react-toastify'

export const Base_url = "https://api.notifyi.in/";
export const Base_media_url = "https://media.notifyi.in/";
export const acz = {
    clientId: 74,
    appId: 'DedQwgPhEQcYckBmqrnPNAkoic8E5N'
}

export default class AdmissionApi {
    constructor() {
        localStorage.setItem('clientId', localStorage.getItem('clientId') ? localStorage.getItem('clientId') : 1);
        localStorage.setItem('appId', localStorage.getItem('appId') ? localStorage.getItem('appId') : "qRQ3v5bmXC0p2rCPpZFaGUtvuCXeZn");
        this.state = {
            clientId: 1,
            appId: "qRQ3v5bmXC0p2rCPpZFaGUtvuCXeZn"
        };
        this.userInfo = {};
    }

    setObj = function (data) {
        this.state = { clientId: data.clientId, appId: data.appId };

        localStorage.setItem('clientId', data.clientId);
        localStorage.setItem('appId', data.appId);
    }

    setUserInfo = function (data) {
        this.userInfo = data;
    }

    getUserInfo = function (callback) {
        console.log("api " + JSON.stringify(this.userInfo));
        callback(this.userInfo);
    }

    GetData = function (callback, url) {
        var config = {
            headers: {
                "Access-Control-Allow-Headers": "Content-Type",
                'Content-Type': 'application/json',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==',
                'x-api-name': 'admissionalert',
                'x-client-id': 1,
                'appId': localStorage.getItem('appId'),
                'clientId': localStorage.getItem('clientId'),
                'x-api-key': localStorage.getItem('appId'),
            }
        };
        axios.get(Base_url + '' + url, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    createNew = function (callback, data, url) {
        var config = {
            headers: {
                "Access-Control-Allow-Headers": "Content-Type",
                'Content-Type': 'application/json',
                'x-client-id': 1,
                'x-api-name': 'admissionalert',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==',
                'appId': localStorage.getItem('appId'),
                'clientId': localStorage.getItem('clientId'),
                'x-api-key': localStorage.getItem('appId'),
            }
        };
        axios.post(Base_url + url, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    if(error.response.data.isInactive) {
                        callback(error.response)
                        toast.success(("We have just sent you an OTP to activate your account."))
                        return
                    }
                    console.log(error.response.status)
                    if(error.response.status === 401) {
                        toast.error(error.response.data.message)
                        callback(error.response)
                        return
                    }
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    // Used in the CreateStudent component
    GetStudentsData = function (callback, url, data) {
        var config = {
            headers: {
                "Access-Control-Allow-Headers": "Content-Type",
                'Content-Type': 'application/json',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==',
                'x-api-name': 'admissionalert',
                'x-client-id': 1,
                'appId': data.app_key,
                'clientId': data.client_id,
                'x-api-key': localStorage.getItem('appId'),
            }
        };
        axios.get(Base_url + '' + url, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    updateCredentials = function (callback, data, url) {
        var config = {
            headers: {
                "Access-Control-Allow-Headers": "Content-Type",
                'Content-Type': 'application/json',
                'appId': localStorage.getItem('appId'),
                'clientId': localStorage.getItem('clientId'),
            }
        };
        axios.put(Base_url + '' + url + '/' + data.id, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    postUpdate = function (callback, data, url) {
        var config = {
            headers: {
                "Access-Control-Allow-Headers": "Content-Type",
                'Content-Type': 'application/json',
                'appId': localStorage.getItem('appId'),
                'clientId': localStorage.getItem('clientId'),
            }
        };
        axios.post(Base_url + url, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    updateStudentCredentials = function (callback, data, token, url) {
        var config = {
            headers: { 'appId': token.app_id, 'clientId': token.client_id, "Access-Control-Allow-Headers": "Content-Type", 'Content-Type': 'application/json' }
        };
        axios.put(Base_url + '' + url + '/' + data.id, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }



    updateStudent = function (callback, url, id, data) {
        // Normalize accidental braces in url like "{v1/students/123}"
        const cleanUrl = url.replace(/^\{|\}$/g, "");
      
        var config = {
          headers: {
            "Access-Control-Allow-Headers": "Content-Type",
            "Content-Type": "application/json",
            "x-auth-token": "ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==",
            "x-api-name": "admissionalert",
            "x-client-id": 1,
            "appId": acz.appId,
            "clientId": acz.clientId,
            "x-api-key": acz.appId,
          },
        };
      
        axios
          .put(`${Base_url}${cleanUrl}/${id}`, data, config)
          .then(function (response) {
            callback(response);
          })
          .catch(function (error) {
            if (error.response) {
              toast.error("Something went wrong. Please try again later.");
              callback(error.response);
            }
          });
      };
      

    deleteCredentials = function (callback, url, id) {
        var config = {
            headers: {
                'appId': localStorage.getItem('appId'), 
                'clientId': localStorage.getItem('clientId'), 
                "Access-Control-Allow-Headers": "Content-Type", 
                'Content-Type': 'application/json',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==', 
                'x-api-key': localStorage.getItem('appId'),
                'x-client-id': 1
            }
        };

        axios.delete(Base_url + '' + url + '/' + id, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(`\u2014`)
                    }
                }
            })
    }
    
    deleteStudent = function (callback, url, id) {
        var config = {
            headers: {
                'appId': acz.appId, 
                'clientId': acz.clientId, 
                "Access-Control-Allow-Headers": "Content-Type", 
                'Content-Type': 'application/json',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==', 
                'x-api-key': acz.appId,
                'x-client-id': 1
            }
        };

        axios.delete(Base_url + '' + url + '/' + id, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(`\u2014`)
                    }
                }
            })
    }

    updatePassword = function (callback, data, url) {
        var config = {
            headers: { 'appId': localStorage.getItem('appId'), 'clientId': localStorage.getItem('clientId'), "Access-Control-Allow-Headers": "Content-Type", 'Content-Type': 'application/json' }
        };
        axios.put(Base_url + '' + url, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    //otp send service

    sendOtp = function (data) {
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json'
            }
        };
        let msg = "OTP for accessing AdmissionsAlert application is : " + data.otp;
        axios.get("http://www.smsjust.com/sms/user/urlsms.php?username=admizzionzcampuz&pass=0@!K2Jha&senderid=NOTFYI&dest_mobileno=" + data.destination_mobile_no + "msgtype=UNI" + "&message=" + msg + "&response=Y")
            .then(function (response) {
                console.log("Otp sent ......." + JSON.stringify(response));
            })
    }

    sendSms = function (cb, data) {
        var config = {
            headers: {
                'appId': localStorage.getItem('appId'), 
                'clientId': localStorage.getItem('clientId'), 
                "Access-Control-Allow-Headers": "Content-Type", 
                'Content-Type': 'application/json', 
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==', 
                'x-api-key': localStorage.getItem('appId'),
                'x-api-name': 'admissionalert',
                'x-client-id': 1
            }
        };
        data.appid = localStorage.getItem('appId');
        data.clientid = localStorage.getItem('clientId');
        axios.post(Base_url + 'settings/v1/sms/send', data, config)
            .then(function (response) {
                cb(response);
            })
            .catch(function (error) {
                toast.error(("Something went wrong. Please try again later."))
                cb(error.response)
            })
    }

    createSlug = function (callback, data, url) {
        var config = {
            headers: {
                'appId': localStorage.getItem('appId'), 'clientId': localStorage.getItem('clientId'), 'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
                "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
                "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers", 'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==', 'x-api-key': localStorage.getItem('appId'),
                'x-api-name': 'admissionalert',
                'x-client-id': 1
            }
        };
        axios.post(Base_url + '' + url, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    sendMail = function (callback, data, url) {
        var config = {
            headers: {
                'appId': localStorage.getItem('appId'), 
                'clientId': localStorage.getItem('clientId'), 
                "Access-Control-Allow-Headers": "Content-Type", 
                'Content-Type': 'application/json', 
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==', 
                'x-api-key': localStorage.getItem('appId'),
                'x-api-name': 'admissionalert',
                'x-client-id': 1
            }
        };
        data.appid = localStorage.getItem('appId');
        data.clientid = localStorage.getItem('clientId');
        axios.post(Base_url + '' + url, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    // toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    //for meidas

    GetMediaData = function (callback, url) {
        var config = {
            headers: {
                'appId': localStorage.getItem('appId'), 'clientId': localStorage.getItem('clientId'), "Access-Control-Allow-Headers": "Content-Type", 'Content-Type': 'application/json',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==', 'x-api-key': localStorage.getItem('appId'),
                'x-api-name': 'admissionalert',
                'x-client-id': 1
            }
        };
        axios.get(Base_media_url + '' + url, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    createMediaNew = function (callback, data, url) {

        var config = {
            headers: {
                'appId': localStorage.getItem('appId'), 'clientId': localStorage.getItem('clientId'), "Access-Control-Allow-Headers": "Content-Type", 'Content-Type': 'application/json',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==', 'x-api-key': localStorage.getItem('appId'),
                'x-api-name': 'admissionalert',
                'x-client-id': 1
            }
        };
        axios.post(Base_media_url + '' + url, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    uploadMedia = function (url, data) {
        var config = {
            headers: {
                'appId': localStorage.getItem('appId'), 'clientId': localStorage.getItem('clientId'), "Access-Control-Allow-Headers": "Content-Type", 'Content-Type': 'application/json',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==', 'x-api-key': localStorage.getItem('appId'),
                'x-api-name': 'admissionalert',
                'x-client-id': 1
            }
        }

        return axios.post(Base_media_url + url, data, config)
            .then(res => res.data)
            .catch(err => err)
    }

    updateMediaCredentials = function (callback, data, url) {
        var config = {
            headers: { 'appId': localStorage.getItem('appId'), 'clientId': localStorage.getItem('clientId'), "Access-Control-Allow-Headers": "Content-Type", 'Content-Type': 'application/json' }
        };
        axios.put(Base_media_url + '' + url + '/' + data.id, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    deleteMediaCredentials = function (callback, url, id) {
        var config = {
            headers: {
                'appId': localStorage.getItem('appId'), 'clientId': localStorage.getItem('clientId'), "Access-Control-Allow-Headers": "Content-Type", 'Content-Type': 'application/json',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==', 'x-api-key': localStorage.getItem('appId'),
                'x-client-id': 1
            }
        };

        axios.delete(Base_media_url + '' + url + '/' + id, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status === 404) {
                        callback(`\u2014`)
                    }
                }
            })
    }

    getAds = function (callback, url, data) {
        var config = {
            headers: {
                "Access-Control-Allow-Headers": "Content-Type",
                'Content-Type': 'application/json',
                'x-client-id': 1,
                'x-api-name': 'admissionalert',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==',
                'appid': localStorage.getItem('appId'),
                'clientid': localStorage.getItem('clientId'),
                'x-api-key': localStorage.getItem('appId'),
            }
        };
        axios.post(Base_url + url, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    createAd = function (callback, data, url) {
        var config = {
            headers: {
                "Access-Control-Allow-Headers": "Content-Type",
                'Content-Type': 'application/json',
                'x-client-id': 1,
                'x-api-name': 'admissionalert',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==',
                'appId': localStorage.getItem('appId'),
                'clientId': localStorage.getItem('clientId'),
                'x-api-key': localStorage.getItem('appId'),
            }
        };
        axios.post('http://notifyi.in:5010/' + url, data, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(error.response)
                    } else {
                        callback(error.response)
                    }
                }
            })
    }

    deleteAd = function (callback, url, id) {
        var config = {
            headers: {
                'appId': localStorage.getItem('appId'),
                'clientId': localStorage.getItem('clientId'),
                "Access-Control-Allow-Headers":
                "Content-Type", 'Content-Type': 'application/json',
                'x-auth-token': 'ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==', 'x-api-key': localStorage.getItem('appId'),
                'x-client-id': 1
            }
        };

        axios.delete(Base_url + url + '?id=' + id, config)
            .then(function (response) {
                callback(response);
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(("Something went wrong. Please try again later."))
                    if (error.response.status === 404) {
                        callback(`\u2014`)
                    }
                }
            })
    }


    // School Codes

createSchoolCode = function (callback, url, data) {
    const config = {
      headers: {
        "Access-Control-Allow-Headers": "Content-Type",
        "Content-Type": "application/json",
        "x-auth-token": "ZlNQZlVPUFZpSjl0MU5paVdXZXhYbkE2QURiOGNyeWdnTXJhaVZSZw==",
        "x-api-name": "admissionalert",
        "x-client-id": 1,
        appId: acz.appId,
        clientId: acz.clientId,
        "x-api-key": acz.appId,
      },
    };
    axios.post(Base_url + url, data, config)
      .then((response) => callback(response))
      .catch((error) => {
        if (error.response) {
          toast.error("Something went wrong. Please try again later.");
          callback(error.response);
        }
      });
  };
  

}


/** WEBPACK FOOTER **
 ** ./src/Services/AdmissionApi.js
 **/